/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LastTransactionFailureParser = 
/* #__PURE__ */ parsers.object([['failedAt', parsers.moment, 'failed_at']]);
export class LastTransactionFailure extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LastTransactionFailureParser.decode(input).map(res => new LastTransactionFailure(res));
    }
    static unsafeDecode(input) {
        return LastTransactionFailure.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LastTransactionFailureParser.encode(data);
    }
    static schema() {
        return LastTransactionFailureParser.schema();
    }
}
